import React, { useEffect } from 'react';
import CoursePart from './CourseSection';
import ScrollToTop from '../../components/Common/ScrollTop';


const CourseMain = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <React.Fragment>

            {/* CoursePart Start */}
            <CoursePart />
            {/* CoursePart End */}

			{/* scrolltop-start */}
			<ScrollToTop
				scrollClassName="scrollup orange-color"
			/>
			{/* scrolltop-end */}

        </React.Fragment>
    )
}

export default CourseMain;